import { Roles } from '@/entities/roles'
import { DisputModel, DisputStatusIcons, DisputStatusTitles } from '@/features/orders/model'
import { StatusLabel } from '@/shared/components'
import { ItemBaseBlock } from '@/shared/components/ItemBaseBlock/ItemBaseBlock'
import { formatDate } from '@/shared/lib/date'

type Props = {
  disput: DisputModel
  userRole?: Roles | null
}

export const DisputBlock = ({ disput }: Props) => {
  const subtitleClasses = 'text-sm text-text-secondary'
  const columnClasses = 'flex flex-col gap-[10px] md:gap-4'

  const status = DisputStatusIcons[disput.status]
  const title = DisputStatusTitles[disput.status]
  const date = formatDate(disput.createdAt, 'long', {})

  return (
    <ItemBaseBlock title="Диспут" type="disput" id={disput.id}>
      <div className="flex md:flex-row flex-col justify-between items-start gap-6 md:gap-2 text-sm">
        <div className={columnClasses}>
          <span className={subtitleClasses}>Ид диспута</span>
          <span className="font-klein font-medium">{disput.id ?? 'Нет данных'}</span>
        </div>

        <div className={columnClasses}>
          <span className={subtitleClasses}>Дата создания</span>
          <span className="font-klein font-medium">{date ?? 'Нет данных'}</span>
        </div>

        <div className={columnClasses}>
          <span className={subtitleClasses}>Статус</span>
          <StatusLabel status={status}>{title}</StatusLabel>
        </div>

        {/* Конверсия */}
        <div className={columnClasses}>
          <span className={subtitleClasses}>Информация об ордере</span>
          <span className="font-klein font-medium">{disput.description ?? 'Нет данных'}</span>
        </div>
      </div>
    </ItemBaseBlock>
  )
}
